export const SAVE_ADDRESS_PROOF = 'SAVE_ADDRESS_PROOF'
export const SAVE_ADDRESS_PROOF_FRONT_SIDE = 'SAVE_ADDRESS_PROOF_FRONT_SIDE'
export const SAVE_ADDRESS_PROOF_BACK_SIDE = 'SAVE_ADDRESS_PROOF_BACK_SIDE'
export const RESET_ADDRESS_PROOF = 'RESET_ADDRESS_PROOF'

export const saveAddressProof = (addressProof) => ({ type: SAVE_ADDRESS_PROOF, addressProof })
export const saveAddressProofFrontSide = (addressProofFrontSide) => ({ type: SAVE_ADDRESS_PROOF_FRONT_SIDE, addressProofFrontSide })
export const saveAddressProofBackSide = (addressProofBackSide) => ({ type: SAVE_ADDRESS_PROOF_BACK_SIDE, addressProofBackSide })
export const resetAddressProof = () => ({ type: RESET_ADDRESS_PROOF })